import { type CustomFetch, type StatusCodeHandlerMap } from '../types';

interface GetCustomResolversFetchInterface {
	fetch: CustomFetch;
	statusCodeHandlers?: StatusCodeHandlerMap;
}

export class FetchError extends Error {
	name: string;
	response: Response;
	responseBody: any;
	status: number;

	constructor(response: Response, resBody: any) {
		super(
			`[FetchError] Request failed with status ${response.status} and statusMessage=${response.statusText}`,
		);

		this.status = response.status;
		this.response = response;
		this.responseBody = resBody;
		this.name = this.constructor.name;
	}
}

function removeEmptyProp(obj: HeadersInit) {
	const result = {
		...obj,
	};
	Object.entries(result).forEach(([key, val]) => {
		if (val === undefined || val === null) {
			// @ts-ignore (TS7053)
			delete result[key];
		}
	});
	return result;
}

// In docs of fetch API, https://developer.mozilla.org/en/docs/Web/API/Fetch_API,
// fetch just throw error for network error, it does not throw error for server error like 400,...
async function handleFetchCommonResponse(res: Response) {
	if (!res.ok) {
		let resBody;

		try {
			resBody = await res.json();
		} catch (e) {
			// ignore parsing body error
		}

		throw new FetchError(res, resBody);
	}

	return res;
}

export const getCustomResolversFetch =
	({ fetch, statusCodeHandlers = {} }: GetCustomResolversFetchInterface): CustomFetch =>
	(url, fetchOptions = {}) => {
		const headers: HeadersInit = {
			'Content-Type': 'application/json',
			...fetchOptions.headers,
		};

		return fetch(url, {
			credentials: 'include',
			...fetchOptions,
			headers: removeEmptyProp(headers),
		})
			.then((response) => {
				const { status } = response;
				const handler = statusCodeHandlers[status];
				if (typeof handler === 'function') {
					handler(response);
				}
				return response;
			})
			.then(handleFetchCommonResponse);
	};
